module.exports = __webpack_public_path__ + "img/f3cac0e.png";